
import { useEffect, useState } from "react"
import { toast } from "@/components/ui/use-toast";
import { useAuth } from "@/contexts/AuthProvider";
import { AutenticarPorCodigoStepEmailInvalido } from "./AutenticarPorCodigoStepEmailInvalido";
import { AutenticarPorCodigoStepEmailValido } from "./AutenticarPorCodigoStepEmailValido";
import { AutenticarPorCodigoStepInicial } from "./AutenticarPorCodigoStepInicial";
import { useNavigate } from "react-router-dom";

export function AutenticarPorCodigo() {
    const [step, setStep] = useState<'Inicial' | 'EmailValido' | 'EmailInvalido'>('Inicial');
    const [cpfDigitado, setCpfDigitado] = useState('');
    const [destino, setDestino] = useState('');
    const { autenticarPorCodigo, isAuthorized } = useAuth();
    const navigate = useNavigate();

    async function handleInicial(emailValido: boolean, cpf: string, destino: string) {
        if (emailValido) {
            setStep('EmailValido')
        } else {
            setStep('EmailInvalido')
        }
        setDestino(destino)
        setCpfDigitado(cpf)
    }

    async function verificarRecaptcha() {
        try {
            const grecaptcha = (window as any).grecaptcha;
            const token = await grecaptcha.execute('6LdL-BcsAAAAAMp9u6pw0p90qR518KgqzfiSihU3', { action: 'submit' })!;
            return token;
        } catch (error: any) {
            toast({
                variant: 'destructive',
                description: error,
                duration: 4000
            });
            return null;
        }
    }

    async function handleVerificacao(codigo: string, emailValido: boolean, cpf: string, email?: string) {
        try {
            if (!codigo) {
                toast({
                    variant: 'destructive',
                    description: 'Insira o código de verificação',
                    duration: 3000
                })
            }

            if (!emailValido && !email) {
                toast({
                    variant: 'destructive',
                    description: 'Insira o email',
                    duration: 3000
                })
                return;
            }

            const recaptchaToken = await verificarRecaptcha();
            if (!recaptchaToken) {
                toast({
                    variant: 'destructive',
                    description: 'Erro ao verificar recaptcha',
                    duration: 3000
                });
                return;
            }

            await autenticarPorCodigo(recaptchaToken, cpf, codigo, email);
            navigate('/compra/extrato-compras');
        } catch (error: any) {
            toast({
                variant: 'destructive',
                description: error,
                duration: 3000
            });
        }
    }

    useEffect(() => {
        if (isAuthorized) {
            navigate('/compra/extrato-compras');
        }

    }, [])

    return (
        <>
            <div className="mx-4 flex-col">
                <h2 className="text-primary-foreground font-bold text-2xl">Autenticar por Código</h2>
                <p>Autentique-se para visualizar suas compras</p>
            </div>

            {step === 'Inicial' && <AutenticarPorCodigoStepInicial handleInicial={handleInicial} />}
            {step === 'EmailValido' && <AutenticarPorCodigoStepEmailValido cpf={cpfDigitado} destino={destino} setStep={setStep} handleVerificacao={handleVerificacao} />}
            {step === 'EmailInvalido' && <AutenticarPorCodigoStepEmailInvalido cpf={cpfDigitado} destino={destino} setStep={setStep} handleVerificacao={handleVerificacao} />}
        </>
    )


}